/**
 * In welchem Ablauf steckt der Bediener gerade — für die Fehlermeldung.
 *
 * „Speichern geht nicht" ist in einem sechsschrittigen Assistenten eine andere
 * Meldung als auf einer Seite: Ohne den Schritt muss die Person, die den Fehler
 * nachstellt, den ganzen Ablauf noch einmal durchspielen, um überhaupt an die
 * Stelle zu kommen. Der Assistent weiss sie ohnehin, also hält er sie hier fest.
 *
 * Bewusst ein Modul-Zustand und kein Context: Den Melde-Dialog hängt das
 * DashboardLayout ein, der Assistent steht irgendwo darunter in einem Portal.
 * Ein Provider müsste beide umschliessen und käme in jeden Assistenten.
 */

import { useSyncExternalStore } from 'react';

export interface WorkflowStand {
  /** Titel des Assistenten, z. B. „Probestunde anlegen". */
  name: string;
  /** Aktueller Schritt, 1-basiert wie in der Anzeige. */
  schritt?: number;
  /** Wie viele Schritte es insgesamt gibt. */
  schritte?: number;
  /** Beschriftung des Schritts, z. B. „Teilnehmer". */
  schrittName?: string;
}

let stand: WorkflowStand | null = null;

/** Meldet den laufenden Ablauf an; `null` beim Verlassen. */
export function setzeWorkflow(neu: WorkflowStand | null): void {
  stand = neu;
}

export function aktuellerWorkflow(): WorkflowStand | null {
  return stand;
}

// --- Ob gemeldet werden darf -------------------------------------------------
//
// Der schwebende Knopf fragt das Modul einmal ab. Assistenten brauchen dieselbe
// Antwort für ihr Kopfzeilen-Symbol, sollen sie aber nicht ein zweites Mal
// stellen — deshalb reicht der Knopf sie hier weiter.

let verfuegbar = false;
const horcher = new Set<() => void>();

export function setzeMeldenVerfuegbar(wert: boolean): void {
  if (verfuegbar === wert) return;
  verfuegbar = wert;
  horcher.forEach((fn) => fn());
}

function abonniere(fn: () => void): () => void {
  horcher.add(fn);
  return () => {
    horcher.delete(fn);
  };
}

/** Ob es das Testing-Modul auf diesem System gibt. */
export function useMeldenVerfuegbar(): boolean {
  return useSyncExternalStore(
    abonniere,
    () => verfuegbar,
    // Auf dem Server gibt es keinen Knopf.
    () => false
  );
}
